import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col items-start gap-6 rounded-lg bg-primary-600 p-7 md:flex-row md:items-center md:justify-between md:p-10">
          <div>
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">手上有可核对的材料？</h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
              录音、录屏、合同照片、转账记录都可以提交。我们会先与你确认材料范围与展示方式，再决定是否公开。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/about#submit"
              className="whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-center text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
            >
              提交材料
            </Link>
            <Link
              to="/cases"
              className="whitespace-nowrap rounded-md border border-primary-300 px-5 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              先看看已公开的
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}